/**
 * Get color for blog category
 * @param {string} category - Blog category name
 * @returns {string} Hex color code
 */
export const getCategoryColor = (category) => {
  const colors = {
    'Direct Tax': '#3b82f6',
    'Indirect Tax': '#10b981',
    'International Tax': '#f59e0b',
    'Zakat': '#8b5cf6',
    'Regulatory': '#ef4444',
    'Compliance': '#06b6d4',
    'Tax Treaties': '#ec4899',
    'Government Incentives': '#14b8a6',
    'Corporate Tax': '#f97316',
  };
  return colors[category] || '#6b7280';
};
